export class UserSettingsCandidateFeedbackDefaults {
  email: string = ""
  enableCandidateFeedbackOption: boolean = false
}
